import React from 'react'

import {isNil, noop} from 'es-toolkit'

import './radio-pill-item.scss'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'label'>,
  {
    label: React.ReactNode
    size?: '90' | '100'
    aside?: React.ReactNode
    name?: string
    checked?: boolean
    value?: string
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    id?: string
  }
>

const RadioPillItem = ({
  className,
  id,
  name,
  label,
  size = '100',
  aside,
  checked = false,
  onChange = noop,
  value = '',
  ...props
}: Props) => {
  const actualId = useUniqueId(id)

  return (
    <label
      {...props}
      htmlFor={actualId}
      className={cn('RadioPillItem', {[`size-${size}`]: !!size, checked}, className)}
      aria-checked={checked}
    >
      <input
        id={actualId}
        className="RadioPillItem__input"
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <div className="RadioPillItem__label">{label}</div>
      {!isNil(aside) && <div className="RadioPillItem__aside">({aside})</div>}
    </label>
  )
}

export default RadioPillItem
